/* eslint no-param-reassign: "error" */
import React, {
  useCallback,
  useEffect,
} from 'react';
import {
  Route,
  Routes,
  Navigate,
  useParams,
} from 'react-router-dom';
import {
  shallowEqual,
  useDispatch,
  useSelector,
} from 'react-redux';
import {
  getStatus,
} from 'redux-resource';

import {
  coreActions,
  coreSelectors,
} from '@gymcloud/core';

import {
  Flex,
} from 'web-styled';

import {
  Spinner,
  NotFound,
  UserDetails,
  PersonalExercise,
} from 'web-components';

import EditProfile from './EditProfile';

const tabs = ['programs', 'workouts', 'exercises', 'videos', 'calendar', 'documents'];

const UsersPage = () => {
  const params = useParams();
  const id = params.id || 'me';

  const mapState = useCallback((state) => {
    const profileId = coreSelectors.getProfile('id')(state);
    return {
      readStatus: getStatus(
        state,
        [
          'clients.requests.fetchClient.status',
        ],
        true,
      ),
      profileId,
      clientInfo: coreSelectors.getClientInfo(
        id === 'me' ? profileId : +id,
      )(state),
    };
  }, [id]);

  const {
    readStatus,
    profileId,
    clientInfo,
  } = useSelector(mapState, shallowEqual);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      coreActions.requestFetchClient(id),
    );
    dispatch(
      coreActions.requestDocuments(),
    );
  }, [id]);

  return (
    <Flex fillSpace>
      {readStatus.succeeded && (
        <Routes>
          <Route
            index
            element={(
              <Navigate to="programs" replace />
            )}
          />
          <Route
            path="edit"
            element={(
              <EditProfile
                profileId={profileId}
                clientInfo={clientInfo}
              />
            )}
          />
          <Route
            path="exercises/:id"
            element={(
              <PersonalExercise
                clientInfo={clientInfo}
              />
            )}
          />
          {tabs.map(tabName => (
            <Route
              key={tabName}
              path={tabName}
              element={(
                <UserDetails
                  id={id}
                  tabName={tabName}
                  clientInfo={clientInfo || {}}
                />
              )}
            />
          ))}
          <Route
            path="*"
            element={<NotFound />}
          />
        </Routes>
      )}

      {readStatus.pending && (
        <Spinner />
      )}

      {readStatus.failed && (
        <NotFound title="Something is wrong" />
      )}
    </Flex>
  );
};

export default UsersPage;
